import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { FileText } from 'lucide-react'

const features = [
  { name: 'Proposal Templates', description: 'Use customizable templates for quick creation' },
  { name: 'Pricing Builder', description: 'Build pricing tables with product catalog' },
  { name: 'Status Tracking', description: 'Track proposal status from draft to signed' },
  { name: 'Approval Workflow', description: 'Internal approval before sending to clients' },
]

export default function ProposalsView() {
  return (
    <PlaceholderPage
      title="Proposals"
      description="Create and manage customer proposals"
      icon={FileText}
      features={features}
      accentColor="orange"
    />
  )
}
